import { useEffect, useRef, useState } from 'react';
import uploadIcon from '../../images/upload-icon-1.svg';
import './AddClientModal.css';

// The table frame is an additional entry point into the existing Add Client
// intake; dropping onto a row never attaches a document to that existing client.
export default function ClientsDocumentDropZone({ enabled, onFiles, children }) {
  const frame = useRef(null);
  const onFilesRef = useRef(onFiles);
  onFilesRef.current = onFiles;
  const [active, setActive] = useState(false);
  useEffect(() => {
    setActive(false);
    const inside = target => target instanceof Node && frame.current?.contains(target);
    const isFiles = e => Array.from(e.dataTransfer?.types || []).includes('Files') || !!e.dataTransfer?.files?.length;
    const reset = () => setActive(false);
    const over = e => {
      if (!isFiles(e)) return;
      const within = inside(e.target);
      setActive(enabled && within);
      if (within) {
        e.preventDefault();
        e.dataTransfer.dropEffect = enabled ? 'copy' : 'none';
      }
    };
    const drop = e => {
      reset();
      if (!isFiles(e) || !inside(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      const files = Array.from(e.dataTransfer.files || []);
      if (enabled && files.length) onFilesRef.current(files);
    };
    const leave = e => { if (!e.relatedTarget) reset(); };
    const key = e => { if (e.key === 'Escape') reset(); };
    document.addEventListener('dragover', over, true);
    document.addEventListener('drop', drop, true);
    document.addEventListener('dragleave', leave, true);
    document.addEventListener('dragend', reset, true);
    document.addEventListener('keydown', key);
    window.addEventListener('blur', reset);
    return () => {
      document.removeEventListener('dragover', over, true);
      document.removeEventListener('drop', drop, true);
      document.removeEventListener('dragleave', leave, true);
      document.removeEventListener('dragend', reset, true);
      document.removeEventListener('keydown', key);
      window.removeEventListener('blur', reset);
    };
  }, [enabled]);
  return <div ref={frame} className="clientsTableDropZone">
    {children}
    {active && <div className="addClientDocumentDropOverlay clientsTableDropOverlay" aria-hidden="true">
      <div className="addClientDocumentDropContent">
        <span className="addClientDocumentDropIcon" style={{'--upload-icon': `url("${uploadIcon}")`}} />
        <span>Drop an ID, proof of address, trade licence or CV</span>
      </div>
    </div>}
  </div>;
}
